module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-8"
  }, [_c('div', {
    staticClass: "card card-default widget animated"
  }, [_c('div', {
    staticClass: "card-heading"
  }, [_c('form', {
    on: {
      "submit": _vm.createWorkflow
    }
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('h5', [_vm._v("Trigger")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('form-text', {
    attrs: {
      "label": "If",
      "name": "if",
      "validation": "required"
    },
    model: {
      value: (_vm.trigger.if),
      callback: function($$v) {
        _vm.$set(_vm.trigger, "if", $$v)
      },
      expression: "trigger.if"
    }
  }), _vm._v(" "), _c('form-text', {
    attrs: {
      "label": "Then",
      "name": "then",
      "validation": "required"
    },
    model: {
      value: (_vm.trigger.then),
      callback: function($$v) {
        _vm.$set(_vm.trigger, "then", $$v)
      },
      expression: "trigger.then"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(0)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-success btn-lg",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Create")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-648311c6","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/operations/AlertsNotifications/CreateTrigger.vue
// module id = 634
// module chunks = 1